import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '../../../shared/modal/content';
import PopupHeader from '../../popupHeader';
import CenterPanelUpdate from './centerPanelUpdate';
import CenterPanelView from './centerPanelView';
import RightPanel from './rightPanel';
import { isStringEmpty } from 'businessLogic/validation.js';
export default function OrgUnitSupportContactModal(props) {
  const updatedOrgUnitSupportContactForm = useSelector(
    (state) => state.organisationsReducer.updatedOrgUnitSupportContactForm
  );

  let centerPanel = '';
  if (props.updateOrView == 'update') {
    centerPanel = <CenterPanelUpdate updatedOrgUnitSupportContactForm={updatedOrgUnitSupportContactForm} />;
  } else {
    centerPanel = <CenterPanelView updatedOrgUnitSupportContactForm={updatedOrgUnitSupportContactForm} />;
  }

  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.OrgUnit.HelpOrgUnitSupportContact}
        title={APP.LANGUAGE.OrgUnitSupportContact.Title}
        subtitle={props.selectedOrgUnit.name}
      />
      <div className="content">
        <div className="main-ui-container waiting-area-during-calls">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <RightPanel
                updateOrView={props.updateOrView}
                updatedOrgUnitSupportContactForm={updatedOrgUnitSupportContactForm}
                selectedOrgUnit={props.selectedOrgUnit}
              />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <RightPanel
                updateOrView={props.updateOrView}
                updatedOrgUnitSupportContactForm={updatedOrgUnitSupportContactForm}
                selectedOrgUnit={props.selectedOrgUnit}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
